import { SizableText, SmartLink, Stack, StackProps } from '@my/ui'

interface ArticleCategoryTagProps {
  name: string
  href: string
}

export const ArticleCategoryTag = ({
  name,
  href,
  ...props
}: ArticleCategoryTagProps & StackProps) => {
  if (!name || !href) return null

  return (
    <SmartLink
      Component={Stack}
      href={href}
      py="$1.5"
      px="$3"
      bc="$primary3"
      br="$3"
      maxWidth={230}
      hoverStyle={{
        bc: '$primary4',
      }}
      focusStyle={{
        bc: '$primary4',
      }}
      pressStyle={{
        opacity: 0.8,
        bc: '$primary4',
      }}
      {...props}
    >
      <SizableText color="$overlay12" numberOfLines={1} size="$4" fow="600">
        {name}
      </SizableText>
    </SmartLink>
  )
}
